<div class="p-6 space-y-4">
  @if (error) {
    <div class="p-3 bg-error-50 dark:bg-error-500/10 border border-error-200 dark:border-error-500/20 rounded-lg text-sm text-error-700 dark:text-error-400">{{ error }}</div>
  }
  <form [formGroup]="form" (ngSubmit)="guardar()" class="space-y-4">
    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
        Nombre <span class="text-error-500">*</span>
      </label>
      <input type="text" formControlName="name" maxlength="150"
        class="w-full px-2.5 py-1.5 text-sm border rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500"
        [class.border-error-500]="hasError('name')"
        [class.border-gray-300]="!hasError('name')" />
    </div>

    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Descripción</label>
      <textarea formControlName="description" rows="2"
        class="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-brand-500 resize-none"></textarea>
    </div>

    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
        Prioridad
      </label>
      <select formControlName="priority"
        class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500">
        @for (p of priorities; track p.id) {
          <option [ngValue]="p.level">{{ priorityOptionLabel(p) }}</option>
        }
      </select>
    </div>

    <!-- Trigger -->
    <div class="rounded-lg border border-gray-200 dark:border-gray-700 p-3 space-y-3">
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Trigger <span class="text-error-500">*</span>
        </label>
        <select formControlName="triggerType"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
          @for (t of triggerTypes; track t) {
            <option [value]="t">{{ triggerLabels[t] }}</option>
          }
        </select>
      </div>

      @if (triggerUsesBreachKind) {
        <div>
          <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Tipo de SLA</label>
          <select [ngModel]="breachKind" (ngModelChange)="breachKind = $event"
            [ngModelOptions]="{ standalone: true }"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
            <option value="">Cualquiera</option>
            @for (b of breachKinds; track b.value) {
              <option [value]="b.value">{{ b.label }}</option>
            }
          </select>
        </div>
      }

      @if (triggerUsesReopen) {
        <div>
          <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">
            Reaperturas mínimas <span class="text-error-500">*</span>
          </label>
          <input type="number" min="1" [ngModel]="reopenCountGte" (ngModelChange)="reopenCountGte = $event"
            [ngModelOptions]="{ standalone: true }" placeholder="Ej. 2"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500" />
        </div>
      }
    </div>

    <!-- Acción -->
    <div class="rounded-lg border border-gray-200 dark:border-gray-700 p-3 space-y-3">
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Acción <span class="text-error-500">*</span>
        </label>
        <select formControlName="actionType"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
          @for (a of actionTypes; track a) {
            <option [value]="a">{{ actionLabels[a] }}</option>
          }
        </select>
      </div>

      @if (actionType === 'INCREASE_PRIORITY') {
        <div>
          <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Niveles a subir</label>
          <input type="number" min="1" [ngModel]="steps" (ngModelChange)="steps = $event"
            [ngModelOptions]="{ standalone: true }" placeholder="1"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500" />
        </div>
      }

      @if (actionType === 'REASSIGN_NEXT_LEVEL') {
        <div>
          <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">
            Reasignar a <span class="text-error-500">*</span>
          </label>
          <app-entity-select
            [value]="toUserId"
            [displayText]="toUserDisplay"
            [searchFn]="userSearchFn"
            [labelFn]="userLabelFn"
            [sublabelFn]="userSublabelFn"
            [idFn]="userIdFn"
            [allowClear]="true"
            placeholder="Buscar usuario por nombre o correo…"
            (valueChange)="toUserId = $event"></app-entity-select>
        </div>
      }

      @if (actionType === 'CHANGE_PIPELINE') {
        <div>
          <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">
            Pipeline destino <span class="text-error-500">*</span>
          </label>
          <select [ngModel]="newPipelineId" (ngModelChange)="newPipelineId = $event"
            [ngModelOptions]="{ standalone: true }"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
            <option [ngValue]="null">Seleccionar pipeline…</option>
            @for (pl of pipelines; track pl.id) {
              <option [ngValue]="pl.id">{{ pl.name }}</option>
            }
          </select>
        </div>
      }

      @if (actionType === 'NOTIFY_MANAGER') {
        <p class="text-xs text-gray-400">Notifica al responsable del ticket. No requiere configuración adicional.</p>
      }
    </div>

    <label class="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
      <input type="checkbox" formControlName="isActive" class="rounded border-gray-300 dark:border-gray-600" />
      Activa
    </label>

    <div class="flex justify-end gap-2 pt-3 border-t border-gray-200 dark:border-gray-700">
      <app-button variant="outline" type="button" (btnClick)="cancelar()">Cancelar</app-button>
      <app-button type="button" [disabled]="saving" (btnClick)="guardar()">
        @if (saving) { Guardando… } @else { {{ isEditing ? 'Actualizar' : 'Guardar' }} }
      </app-button>
    </div>
  </form>
</div>
